<script>
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { getPath } from '../../utils/imageKit.ts';

  let {
    theme = 'blue',
    image = undefined,
    content,
    link,
    rounded = false,
    showButton = false,
    usedInAside = false,
    onClick = undefined,
    dataTestId = 'info-tile',
  } = $props();

  const bgCssClassMap = {
    blue: 'bg-blue-cerulean',
    pink: 'bg-pink',
    gray: 'bg-gray-pale',
    darkblue: 'bg-blue-darkish',
    white: 'group bg-white active:shadow-active shadow-y-sm pseudo-shadow-tight-hover lg-rounded-none',
  };
  const hoverCssClassMap = {
    blue: 'hover-hover:hover:bg-blue-darkish active:bg-blue-darkish',
    pink: 'hover-hover:hover:bg-pink-purplish active:bg-pink-purplish',
    gray: 'hover-hover:hover:bg-gray-light-silver active:bg-gray-light-silver',
    darkblue: 'hover-hover:hover:bg-blue-cerulean active:bg-blue-cerulean',
    white: 'hover-hover:hover:no-underline',
  };
  const textCssClassMap = {
    blue: 'text-white',
    pink: 'text-white',
    gray: 'text-blue-cerulean',
    darkblue: 'text-white',
    white: 'text-body',
  };

  const buttonCssClassMap = {
    blue: 'text-white',
    pink: 'text-white',
    gray: 'text-blue-cerulean',
    darkblue: 'text-white',
    white:
      'bg-blue-bright-cyan text-blue-navy hover-hover:group-hover:bg-blue-robin-egg group-active:bg-blue-robin-egg',
  };

  // Handle Image Setup
  const defaultSrc = getPath(image, { w: 64, ar: '1:1' });
  const highResSrc = getPath(image, { w: 64, ar: '1:1' }, 2);
</script>

<BaseLink
  className={`group w-full min-h-18 px-2 flex items-center relative hover-hover:hover:underline active:underline ${
    bgCssClassMap[theme]
  } ${textCssClassMap[theme]} ${hoverCssClassMap[theme]}
  ${showButton ? 'md:pr-4' : ''} ${rounded ? 'rounded-lg lg:rounded-none' : ''}`}
  {...link}
  {dataTestId}
  {onClick}
>
  {#if image && image.url && image.alt}
    <img
      class="w-16 h-16"
      loading="lazy"
      width="64"
      height="64"
      src={defaultSrc}
      srcset={`${defaultSrc}, ${highResSrc} 2x`}
      sizes="64px"
      alt={image.alt}
    />
  {/if}
  <div class="w-4/6 py-4 grow mx-2 md:mx-4 text-base font-normal leading-tight">
    {@html content}
  </div>
  <svg
    class={`${usedInAside ? 'md:hidden lg:block' : 'md:hidden'} w-4 h-4 ml-auto mr-0 fill-current ${textCssClassMap[theme]}`}
    role="presentation"
  >
    <use xlink:href="{SPRITESHEET_URL}#right-arrow" />
  </svg>

  {#if showButton}
    <div
      class={`hidden ${usedInAside ? 'md:block lg:hidden' : 'md:block'} ${buttonCssClassMap[theme]} font-semibold rounded-sm whitespace-nowrap py-2 px-4 lg:px-8 ${usedInAside ? 'mr-4 ml-8' : ''}`}
    >
      {link.text}
    </div>
  {/if}
</BaseLink>
